// validators/index.js
import activityValidators from "./activity";
import carValidators from "./car";
import flightValidators from "./flight";
import hotelValidators from "./hotel";
import transportValidators from "./transport";
import packageValidators from "./package";
import restaurantValidators from "./restaurant";
import hostingValidators from "./hosting";
import eventValidators from "./event";

const validatorsByProduct = {
  Activity: activityValidators,
  Car: carValidators,
  Transport: transportValidators,
  Hotel: hotelValidators,
  Flight: flightValidators,
  Package: packageValidators,
  Restaurant: restaurantValidators,
  Hosting: hostingValidators,
  Events: eventValidators,
};

const validateProductStep = (productType, state, step, t) => {
  /* if (productType === "Package") {
    return null;
  }*/
  const productValidators = validatorsByProduct[productType];

  if (!productValidators) return null;

  // Run unique step validator if exists
  if (productValidators[step]) {
    const error = productValidators[step](state, t);
    if (error) return error;
  }

  // Run shared validators if defined
  if (productValidators.shared) {
    for (const validator of productValidators.shared) {
      const error = validator(step, state, t);
      if (error) return error;
    }
  }

  return null;
};

export default validateProductStep;
